import React, { useEffect, useRef } from "react";
import "./youtube-auto-play.css";

const YouTubeAutoPlay = () => {
  const iframeRef = useRef(null);

  useEffect(() => {
    if (iframeRef.current) {
      iframeRef.current.src += "&autoplay=1";
    }
  }, []);

  return (
    <div className="youtube-container">
      <iframe
        ref={iframeRef}
        className="youtube-iframe"
        src="https://www.youtube.com/embed/z73_AOhc8n4?si=g1EKbfYQBYNFsXqZ"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default YouTubeAutoPlay;
